import { logger } from '@modules/logger';
import { createContext, useContext } from 'react';

interface SideNavPopupContextValues {
  closePopup: (() => void) | undefined;
}

export const SideNavPopupContext = createContext<SideNavPopupContextValues>({
  closePopup: () => logger.warn('Warning: closePopup is not implemented'),
});

export function usePopupContext(): SideNavPopupContextValues {
  const { closePopup } = useContext(SideNavPopupContext);

  return { closePopup };
}
